import { useState } from "react"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StandardFilterButton } from "../../../../../../shared/components/table/StandardFilterButton"
import { FiltersDrawerMeetingService } from "../../../../../supplier/reporting/accounting/meetingService/components/FiltersDrawerMeetingService"
import { ExpandableSearch } from "../../../../../../shared/components/filters/ExpandableSearch"

import { meetingServiceDisabledFilters, useMeetingServiceFilters } from "../context/MeetingServiceFiltersContext"

export function MeetingServiceSearchAndFilters() {
    const { filtersList, setFiltersList, activeCount, search, setSearch } = useMeetingServiceFilters()
    const [drawerOpen, setDrawerOpen] = useState(false)

    return (
        <>
            <LocalizedStrict id="production-meeting-service-search-field" attrs={{ label: true, placeholder: true }}>
                <ExpandableSearch
                    value={search}
                    onChange={setSearch}
                    label="Search order"
                    placeholder="Type order id, meeting name or host."
                    expandedWidth="25.25rem"
                    bordered
                />
            </LocalizedStrict>
            <StandardFilterButton onClick={() => setDrawerOpen(true)} activeCount={activeCount} bordered />
            <FiltersDrawerMeetingService
                drawerOpen={drawerOpen}
                setDrawerOpen={setDrawerOpen}
                filtersList={filtersList}
                setFiltersList={setFiltersList}
                disabledFilters={meetingServiceDisabledFilters}
            />
        </>
    )
}
